"use client"

import Card from "@/components/ui/Card"
import { Typography } from "@mui/material"
import Image from "next/image"
import { AdminContext, useAdmin } from "@/components/providers/AdminProvider"
import { useContext } from "react"

const Home = (props: { params: { company: string }; searchParams: {} }) => {
  const empresa = useContext(AdminContext)

  if (!empresa || empresa.id === 0) {
    return <div className="flex items-center justify-center h-full w-full min-h-screen text-xl">:)</div>
  }

  // Construct address from available fields
  const addressParts = [empresa.direccion_complemento, empresa.municipio, empresa.departamento].filter(Boolean)

  const fullAddress = addressParts.join(", ")

  return (
    <div className="flex items-center justify-center h-full w-full bg-[#2c3d3e] min-h-screen">
      <Card
        title="Información General"
        variant="dark"
        className="w-full max-w-md flex flex-col gap-6 items-center justify-center p-8 shadow-xl"
      >
        <div className="w-32 h-32 relative">
          <Image
            src={`/static/${empresa.nit}/logo-circle-simple.png`}
            alt={`${empresa.nombre_comercial || empresa.nombre} Logo`}
            fill
            className="object-contain"
            priority
            onError={(e) => {
              // Fallback to default logo if company logo doesn't exist
              const target = e.target as HTMLImageElement
              target.src = "/static/default/logo-circle-simple.png"
            }}
          />
        </div>

        <div className="flex flex-col items-center gap-2 text-center">
          <Typography variant="h4" component="h1" className="font-bold text-white">
            {empresa.nombre_comercial || empresa.nombre}
          </Typography>

          {fullAddress && (
            <Typography variant="body1" component="p" className="text-white">
              {fullAddress}
            </Typography>
          )}

          {empresa.telefono && (
            <Typography variant="body1" component="p" className="text-white mt-2">
              Tel: {empresa.telefono}
            </Typography>
          )}

          {empresa.email && (
            <Typography variant="body1" component="p" className="text-white">
              Email: {empresa.email}
            </Typography>
          )}
        </div>
      </Card>
    </div>
  )
}

export default Home
